import { IndiciaReasonCode } from '@/types/api/tax-info';

export const FOREIGN_INDICIA_REASON_OTHER_MAX_LENGTH = 80;

export const FOREIGN_INDICIA_REASON_GROUPS = [
  {
    id: 'citizenship',
    subheadingKey: 'taxInfoDrawer.question2.foreignIndicia.groups.citizenship',
    optionCodes: [
      IndiciaReasonCode.HOLD_CITIZENSHIP_ONLY_DO_NOT_LIVE_THERE,
      IndiciaReasonCode.NEVER_LIVED_THERE,
      IndiciaReasonCode.NO_LONGER_LIVE_THERE,
      IndiciaReasonCode.NOT_TAX_RESIDENT_UNDER_RULES,
    ],
  },
  {
    id: 'placeOfBirth',
    subheadingKey: 'taxInfoDrawer.question2.foreignIndicia.groups.placeOfBirth',
    optionCodes: [
      IndiciaReasonCode.BORN_THERE_NEVER_LIVED_THERE,
      IndiciaReasonCode.DO_NOT_LIVE_IN_COUNTRY,
      IndiciaReasonCode.NOT_TAX_RESIDENT,
    ],
  },
  {
    id: 'addressResidence',
    subheadingKey:
      'taxInfoDrawer.question2.foreignIndicia.groups.addressResidence',
    optionCodes: [
      IndiciaReasonCode.TEMPORARY_ADDRESS_ONLY,
      IndiciaReasonCode.NO_LONGER_LIVE_AT_ADDRESS,
      IndiciaReasonCode.NOT_TAX_RESIDENT_UNDER_RULES,
    ],
  },
  {
    id: 'employmentBusiness',
    subheadingKey:
      'taxInfoDrawer.question2.foreignIndicia.groups.employmentBusiness',
    optionCodes: [
      IndiciaReasonCode.WORK_THERE_TEMPORARILY_ONLY,
      IndiciaReasonCode.EMPLOYMENT_DOES_NOT_CREATE_TAX_RESIDENCY,
      IndiciaReasonCode.LIMITED_BUSINESS_ACTIVITY,
    ],
  },
] as const;
